import { useEffect } from 'react'
import { useQuery, QueryObserverResult } from '@tanstack/react-query'
import { fetchCompanyDetails } from '@pepper/utils/src/api/users/users'
import { useShowMessage } from '../providers'

type ReturnType = {
  data?: Company
  refetch: () => Promise<QueryObserverResult<void>>
  isLoading: boolean
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useCompanyDetails = (
  index: string,
  id: string | undefined,
  includeFilter?: boolean
): ReturnType => {
  const showMessage = useShowMessage()
  const handleApiRequest = async () => {
    if (!id) return null
    const { status, data, error } = await fetchCompanyDetails(id, includeFilter)
    if (status === 'ok') {
      return data
    } else {
      throw new Error(error)
    }
  }

  const { isError, isLoading, data, refetch } = useQuery({
    queryKey: [index],
    queryFn: handleApiRequest,
    enabled: index ? true : false
  })
  useEffect(() => {
    if (isError) {
      showMessage({
        type: 'error',
        message: 'Error while fetching company details'
      })
    }
  }, [isError, showMessage])

  return {
    isLoading,
    data,
    refetch
  }
}
